<app-auth-layout>
  <div class="main__container flex w-full flex-col">
    <h1
      class="text-xl font-extrabold leading-[1.875rem] text-mango-grey xl:text-2xl xl:leading-[1.3125rem] xl:text-mango-black17"
    >
      Login into your Account
    </h1>

    <p class="cta__text mb-5 mt-[1.88rem] text-sm text-mango-gray74 xl:my-5">
      Enter your details to access your Mango account
    </p>

    <form class="flex flex-col gap-5" [formGroup]="loginForm">
      <!-- Email -->
      <div>
        <app-input-label labelFor="email">Email</app-input-label>
        <div class="input--top-margin">
          <app-input
            [type]="'email'"
            [name]="'email'"
            placeholder="Enter email"
            [autocomplete]="'email'"
            [inputClass]="'input--padding'"
            formControlName="email"
            inputmode="email"
          ></app-input>
        </div>
      </div>

      <!-- Password -->
      <div>
        <app-input-label labelFor="password">Password</app-input-label>
        <div class="input--top-margin relative rounded-md">
          <app-input
            [type]="isPasswordVisible ? 'text' : 'password'"
            name="password"
            placeholder="********"
            required
            [inputClass]="'input--padding'"
            formControlName="password"
          ></app-input>

          <div
            class="password-icon__wrapper absolute inset-y-0 right-0 flex cursor-pointer items-center pr-3"
          >
            <!-- Eye-closed icon -->
            @if (!isPasswordVisible) {
              <svg
                class="h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
                (click)="isPasswordVisible = !isPasswordVisible"
              >
                <path
                  d="M2.35605 5.53793C2.19288 5.15721 1.75197 4.98085 1.37125 5.14402C0.990525 5.30718 0.814162 5.74809 0.977328 6.12881L2.35605 5.53793ZM12.9893 11.1073L12.7147 10.4094L12.7147 10.4094L12.9893 11.1073ZM7.63934 11.5163C7.86524 11.1691 7.76692 10.7046 7.41974 10.4787C7.07255 10.2527 6.60796 10.3511 6.38206 10.6983L7.63934 11.5163ZM5.20472 12.5077C4.97881 12.8549 5.07713 13.3194 5.42431 13.5453C5.7715 13.7713 6.23609 13.6729 6.46199 13.3257L5.20472 12.5077ZM19.0227 6.12881C19.1859 5.74809 19.0095 5.30718 18.6288 5.14402C18.2481 4.98085 17.8072 5.15721 17.644 5.53793L19.0227 6.12881ZM15.8334 9.27407L15.3201 8.72722L15.3201 8.72722L15.8334 9.27407ZM16.553 11.0544C16.8459 11.3473 17.3208 11.3473 17.6137 11.0544C17.9066 10.7615 17.9066 10.2866 17.6137 9.99374L16.553 11.0544ZM9.25002 13.75C9.25002 14.1643 9.58581 14.5 10 14.5C10.4142 14.5 10.75 14.1643 10.75 13.75H9.25002ZM13.538 13.3257C13.764 13.6729 14.2285 13.7713 14.5757 13.5453C14.9229 13.3194 15.0212 12.8549 14.7953 12.5077L13.538 13.3257ZM4.69702 9.8044C4.98991 9.51151 4.98991 9.03664 4.69702 8.74374C4.40412 8.45085 3.92925 8.45085 3.63636 8.74374L4.69702 9.8044ZM2.38636 9.99374C2.09346 10.2866 2.09346 10.7615 2.38636 11.0544C2.67925 11.3473 3.15412 11.3473 3.44702 11.0544L2.38636 9.99374ZM10 10.9167C7.35946 10.9167 5.46135 9.60298 4.19545 8.2397C3.56272 7.5583 3.09848 6.87454 2.79293 6.36122C2.64057 6.10527 2.52884 5.89366 2.45632 5.74861C2.42009 5.67615 2.39373 5.62047 2.37706 5.58439C2.36873 5.56635 2.36283 5.55322 2.35933 5.54536C2.35758 5.54143 2.35644 5.53881 2.35589 5.53756C2.35562 5.53693 2.35549 5.53665 2.35552 5.53671C2.35553 5.53674 2.35558 5.53686 2.35567 5.53706C2.35571 5.53716 2.35581 5.53738 2.35583 5.53743C2.35593 5.53767 2.35605 5.53793 1.66669 5.83337C0.977328 6.12881 0.97746 6.12912 0.977601 6.12945C0.977661 6.12959 0.977813 6.12994 0.977933 6.13022C0.978173 6.13078 0.978453 6.13143 0.978771 6.13216C0.979409 6.13364 0.980202 6.13547 0.981153 6.13764C0.983054 6.142 0.985583 6.14775 0.988743 6.15486C0.995063 6.16907 1.00391 6.1887 1.01531 6.21338C1.03811 6.26275 1.07116 6.3324 1.11468 6.41944C1.20167 6.5934 1.33082 6.83752 1.50399 7.12845C1.84948 7.70887 2.37482 8.48344 3.09626 9.26038C4.53869 10.8138 6.80725 12.4167 10 12.4167V10.9167ZM12.7147 10.4094C11.9199 10.7222 11.0184 10.9167 10 10.9167V12.4167C11.2149 12.4167 12.3024 12.1837 13.264 11.8052L12.7147 10.4094ZM6.38206 10.6983L5.20472 12.5077L6.46199 13.3257L7.63934 11.5163L6.38206 10.6983ZM18.3334 5.83337C17.644 5.53793 17.6441 5.53778 17.6441 5.53764C17.6441 5.5376 17.6442 5.53746 17.6442 5.53738C17.6443 5.53722 17.6444 5.53709 17.6444 5.53699C17.6445 5.53679 17.6445 5.53669 17.6445 5.5367C17.6445 5.53673 17.6443 5.53719 17.6439 5.53807C17.6432 5.53984 17.6416 5.54331 17.6393 5.54842C17.6348 5.55865 17.6272 5.57543 17.6165 5.59826C17.5952 5.64394 17.5618 5.71377 17.5158 5.80381C17.4239 5.98405 17.2827 6.24427 17.0901 6.55327C16.7037 7.17345 16.1181 7.97822 15.3201 8.72722L16.3466 9.82092C17.2641 8.95974 17.9285 8.04416 18.3632 7.34653C18.5812 6.99664 18.7433 6.69859 18.8521 6.48529C18.9065 6.37856 18.9477 6.2928 18.976 6.23209C18.9902 6.20172 19.0011 6.1776 19.0089 6.16022C19.0128 6.15154 19.0159 6.14453 19.0182 6.13928C19.0193 6.13665 19.0203 6.13446 19.021 6.13271C19.0214 6.13184 19.0217 6.13108 19.022 6.13043C19.0222 6.1301 19.0223 6.1298 19.0224 6.12954C19.0225 6.1294 19.0225 6.12922 19.0226 6.12915C19.0226 6.12898 19.0227 6.12881 18.3334 5.83337ZM15.3201 8.72722C14.6132 9.39068 13.7481 10.0026 12.7147 10.4094L13.264 11.8052C14.5097 11.3149 15.5321 10.5855 16.3466 9.82092L15.3201 8.72722ZM15.303 9.8044L16.553 11.0544L17.6137 9.99374L16.3637 8.74374L15.303 9.8044ZM9.25002 11.6667V13.75H10.75V11.6667H9.25002ZM12.3607 11.5163L13.538 13.3257L14.7953 12.5077L13.618 10.6983L12.3607 11.5163ZM3.63636 8.74374L2.38636 9.99374L3.44702 11.0544L4.69702 9.8044L3.63636 8.74374Z"
                  fill="#D0D5DD"
                />
              </svg>
            }

            <!-- Eye-open icon -->
            @if (isPasswordVisible) {
              <svg
                class="h-5 w-5 text-mango-lightGray"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
                stroke-width="1.5"
                stroke="currentColor"
                (click)="isPasswordVisible = !isPasswordVisible"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                />
              </svg>
            }
          </div>
        </div>
      </div>

      <div
        [ngClass]="{
          'cursor-not-allowed': loginForm.invalid
        }"
      >
        <button
          mango-button
          [loading]="(loading$ | async) || loginForm.invalid"
          [disabled]="(loading$ | async) || loginForm.invalid"
          (click)="login()"
          class="submit-button"
        >
          <span *ngIf="loading$ | async" spin></span>
          @if (!(loading$ | async)) {
            Login
          }
        </button>
      </div>
    </form>

    <div
      class="footer mt-[1.88rem] flex flex-col items-center gap-[1.88rem] text-sm xl:mt-5 xl:gap-5"
    >
      <a
        [routerLink]="['/auth/forgot-password']"
        class="leading text-center font-extrabold text-mango"
        >Forgot Password?</a
      >

      <p class="font-light text-mango-gray74">
        New to Mango App?
        <a
          href="#"
          [routerLink]="['/create-account/']"
          class="font-extrabold text-mango"
          >Create Account</a
        >
      </p>

      <div class="flex items-center gap-2">
          <img src="/assets/images/svgs/sec-logo.svg" alt="" class="h-6 w-auto "/>
          <p class="font-light text-xs text-mango-gray74">Mango Asset Management is registered and regulated by the Securities and Exchange Commission, Nigeria</p>
        </div>
    </div>
  </div>
</app-auth-layout>
